import { useRef, useEffect } from "react";
import QRCode from "qrcode";
import { Box } from "@material-ui/core";
import { ButtonCustom } from "../../shared/Style/Style";

interface ShareLinkQrProps {
  shareUrl: string;
  shortCode?: string | null;
}

// Render the QR into a canvas for preview; the saved file is generated separately
// as a higher-res 512px data URL for a sharper scan.
export const ShareLinkQr = ({ shareUrl, shortCode }: ShareLinkQrProps) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (canvasRef.current && shareUrl) {
      QRCode.toCanvas(
        canvasRef.current,
        shareUrl,
        { width: 200, margin: 2 },
        (err) => err && console.error(err),
      );
    }
  }, [shareUrl]);

  const handleSave = async () => {
    try {
      const dataUrl = await QRCode.toDataURL(shareUrl, {
        type: "image/jpeg",
        width: 512,
        margin: 2,
        rendererOpts: { quality: 0.95 },
      });
      const a = document.createElement("a");
      a.href = dataUrl;
      a.download = `${shortCode || "share-link"}.jpg`;
      a.click();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      style={{ gap: 12 }}
    >
      <canvas ref={canvasRef} />
      <ButtonCustom type="button" onClick={handleSave}>
        Зберегти QR (JPG)
      </ButtonCustom>
    </Box>
  );
};
